"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMediaCampaignEventsDto = void 0;
const display_1 = require("../display");
class SearchMediaCampaignEventsDto extends display_1.DisplayEventPageOptionsDto {
}
exports.SearchMediaCampaignEventsDto = SearchMediaCampaignEventsDto;
